/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ project: NonNullable<unknown> }} Delete_Ad_Job_TextInputs */

const en_delete_ad_job_text = /** @type {(inputs: Delete_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this AD generation job for ${i?.project}?`)
};

const fr_delete_ad_job_text = /** @type {(inputs: Delete_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir supprimer cette tâche de génération d'annonces pour ${i?.project} ?`)
};

const de_delete_ad_job_text = /** @type {(inputs: Delete_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchten Sie diesen AD-Generierungsauftrag für ${i?.project} wirklich löschen?`)
};

const it_delete_ad_job_text = /** @type {(inputs: Delete_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare questo processo di generazione di Active Directory per ${i?.project}?`)
};

const ru_delete_ad_job_text = /** @type {(inputs: Delete_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить это задание по генерации AD для ${i?.project}?`)
};

const es_delete_ad_job_text = /** @type {(inputs: Delete_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Está seguro de que desea eliminar este trabajo de generación de AD para ${i?.project}?`)
};

const zh_cn2_delete_ad_job_text = /** @type {(inputs: Delete_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您确定要删除 ${i?.project} 的此 AD 生成作业吗？`)
};

const ja_delete_ad_job_text = /** @type {(inputs: Delete_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project} の AD 生成ジョブを削除してもよろしいですか？`)
};

const hi_delete_ad_job_text = /** @type {(inputs: Delete_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई ${i?.project} के लिए इस AD जनरेशन जॉब को डिलीट करना चाहते हैं?`)
};

const pt_pt2_delete_ad_job_text = /** @type {(inputs: Delete_Ad_Job_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir esta tarefa de geração de AD para ${i?.project}?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete this AD generation job for {project}?" |
*
* @param {Delete_Ad_Job_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const delete_ad_job_text = /** @type {((inputs: Delete_Ad_Job_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Ad_Job_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_delete_ad_job_text(inputs)
	if (locale === "de") return de_delete_ad_job_text(inputs)
	if (locale === "it") return it_delete_ad_job_text(inputs)
	if (locale === "ru") return ru_delete_ad_job_text(inputs)
	if (locale === "es") return es_delete_ad_job_text(inputs)
	if (locale === "zh-CN") return zh_cn2_delete_ad_job_text(inputs)
	if (locale === "ja") return ja_delete_ad_job_text(inputs)
	if (locale === "hi") return hi_delete_ad_job_text(inputs)
	if (locale === "pt-PT") return pt_pt2_delete_ad_job_text(inputs)
	return en_delete_ad_job_text(inputs)
});